import {
  Container,
  Header,
  HeaderTitle,
  HeaderSubtitle,
  HeaderWrapper,
  SubHeaderTitle,
} from "./styles";
import { HeaderProps } from "./types";

export const HeaderComponent: React.FC<HeaderProps> = ({
  title,
  subtitle,
  isHeader = true,
  showDivider = true,
  children,
}) => {
  return (
    <Container>
      <Header>
        <span>
          {isHeader && <HeaderTitle>{title}</HeaderTitle>}
          {!isHeader && <SubHeaderTitle>{title}</SubHeaderTitle>}
          {subtitle !== undefined && (
            <HeaderSubtitle>{subtitle}</HeaderSubtitle>
          )}
        </span>
        {children}
      </Header>
      {isHeader && showDivider && <HeaderWrapper />}
    </Container>
  );
};
